import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import Cookies from "js-cookie";
import auth from "@/general/store/modules/auth";

//永続化対象のState
const persistedState = ["loginInfo.ssoFlg"];

//永続化対象のStateを更新するMutation
const persistedMutations = ["loginInfo/removeAll", "loginInfo/setSsoFlg"];

const baseStore = {
  getItem: (key: string) => Cookies.get(key),
  setItem: (key: string, value: any) => {
    Cookies.set(key, value, {
      domain: process.env.VUE_APP_COOKIE_DOMAIN,
      expires: 3 / 24,
      secure: true
    }); // 3時間有効
  },
  removeItem: (key: string) =>
    Cookies.remove(key, {
      domain: process.env.VUE_APP_COOKIE_DOMAIN,
      path: "/",
      secure: true
    })
};

const store = createStore({
  plugins: [
    createPersistedState({
      key: process.env.VUE_APP_COOKIE_NAME,
      paths: ["auth"],
      storage: window.localStorage
    }),
    createPersistedState({
      key: process.env.VUE_APP_COOKIE_NAME,
      paths: persistedState,
      filter: (mutation) => {
        return persistedMutations.includes(mutation.type);
      },
      // クッキーに永続化
      storage: baseStore
    })
  ]
});

export default store;
